export enum ReportSyncState {
    Pending = 'Pending',
    Ok = 'Ok',
    Error = 'Error',
}
  